<template>
  <v-app class="bg-background">
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      elevation="8"
      max-width="420"
      rounded="lg"
      class="px-3"
      :top="snackbar.top"
      :right="snackbar.right"
    >
      <div class="d-flex align-center">
        <v-icon v-if="snackbar.icon" large class="mr-3">
          {{ snackbar.icon }}
        </v-icon>
        <div class="text-body-1 font-weight-medium">
          {{ snackbar.text }}
        </div>
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn
          v-show="snackbar.button"
          text
          height="36"
          class="ml-4 px-3"
          v-bind="attrs"
          @click="handleAction" 
        >
          {{ snackbar.textButton }}
        </v-btn>
      </template>
    </v-snackbar>

    <LoadingCenter v-if="loadingDataInit" />
    <Loading v-if="loadingInit" :active.sync="loadingInit" />

    <router-view />

  </v-app>
</template>

<script>
import LoadingCenter from "@/util/LoadingNew.vue";
import Loading from "vue-loading-overlay";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "App",
  components: {
    LoadingCenter,
    Loading,
  },
  computed: {
    ...mapState(["loadingInit"]),
    ...mapState("initialData", ["loadingDataInit"]),
    ...mapGetters("alerts", ["snackbar"]),
  },
  methods: {
    ...mapActions("alerts", ["hideSnackbar"]),
    
    // Mantenemos tu lógica de acciones intacta
    handleAction() {
      this.hideSnackbar();
      if (typeof this.snackbar.action === "function") {
        this.snackbar.action();
      }
    },
  },

  // Mantenemos tu bus de eventos para no romper las notificaciones actuales
  mounted() {
    this.$updateBus.$on("showSnackBar", (snackbar) => {
      // Nota: snackbar ya viene del store vía getter, 
      // pero si el bus inyecta datos manuales, esto lo sigue soportando.
      Object.assign(this.snackbar, snackbar);
    });
  },

  // El created con fetchEmpresaPublic se ELIMINA porque 
  // ahora lo hace el guard 'checkEmpresa' de forma asíncrona.
};
</script>

<style>
.theme--dark.v-application {
  background-color: #0f0f0f !important;
}
</style>